var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgricultureEnvironment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.679,
    height: 37.289,
    viewBox: "0 0 10.679 37.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1041",
    "data-name": "Groupe 1041",
    transform: "translate(1915.933 -894.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1713",
    "data-name": "Trac\\xE9 1713",
    d: "M-1911.076,901.819c.783-2.251-.733-3.838-4.636-4.738a.182.182,0,0,0-.217.217c.9,3.9,2.491,5.418,4.74,4.635A.183.183,0,0,0-1911.076,901.819Z",
    transform: "translate(0 2.229)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1714",
    "data-name": "Trac\\xE9 1714",
    d: "M-1912.651,901.82c-.784-2.251.731-3.838,4.634-4.74a.181.181,0,0,1,.217.215c-.9,3.906-2.488,5.422-4.738,4.638A.188.188,0,0,1-1912.651,901.82Z",
    transform: "translate(2.535 2.228)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1715",
    "data-name": "Trac\\xE9 1715",
    d: "M-1912.3,901.078c-2.145-1.035-2.2-3.229-.075-6.628a.182.182,0,0,1,.306,0c2.123,3.4,2.072,5.591-.073,6.628A.173.173,0,0,1-1912.3,901.078Z",
    transform: "translate(1.641)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1716",
    "data-name": "Trac\\xE9 1716",
    d: "M-1911.075,904.315c.782-2.249-.732-3.838-4.638-4.738a.181.181,0,0,0-.215.217c.9,3.9,2.49,5.418,4.74,4.635A.187.187,0,0,0-1911.075,904.315Z",
    transform: "translate(0.001 4.282)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1717",
    "data-name": "Trac\\xE9 1717",
    d: "M-1912.649,904.316c-.786-2.249.731-3.838,4.634-4.74a.181.181,0,0,1,.215.217c-.9,3.9-2.487,5.42-4.736,4.636A.178.178,0,0,1-1912.649,904.316Z",
    transform: "translate(2.536 4.281)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1718",
    "data-name": "Trac\\xE9 1718",
    d: "M-1911.075,906.812c.784-2.249-.732-3.838-4.636-4.738a.182.182,0,0,0-.217.217c.9,3.9,2.491,5.418,4.74,4.634A.183.183,0,0,0-1911.075,906.812Z",
    transform: "translate(0.001 6.334)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1719",
    "data-name": "Trac\\xE9 1719",
    d: "M-1912.65,906.812c-.784-2.249.731-3.838,4.634-4.74a.182.182,0,0,1,.217.217c-.9,3.9-2.488,5.42-4.738,4.636A.183.183,0,0,1-1912.65,906.812Z",
    transform: "translate(2.536 6.334)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1720",
    "data-name": "Trac\\xE9 1720",
    d: "M-1911.074,909.307c.782-2.249-.733-3.838-4.638-4.738a.181.181,0,0,0-.215.217c.9,3.9,2.49,5.42,4.74,4.635A.189.189,0,0,0-1911.074,909.307Z",
    transform: "translate(0.002 8.387)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1721",
    "data-name": "Trac\\xE9 1721",
    d: "M-1912.649,909.308c-.785-2.249.731-3.838,4.635-4.74a.181.181,0,0,1,.215.217c-.9,3.9-2.488,5.42-4.737,4.636A.183.183,0,0,1-1912.649,909.308Z",
    transform: "translate(2.537 8.387)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1722",
    "data-name": "Trac\\xE9 1722",
    d: "M-1911.074,911.8c.783-2.249-.733-3.838-4.636-4.736a.18.18,0,0,0-.217.215c.9,3.9,2.491,5.42,4.74,4.634A.183.183,0,0,0-1911.074,911.8Z",
    transform: "translate(0.002 10.441)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1723",
    "data-name": "Trac\\xE9 1723",
    d: "M-1912.649,911.8c-.783-2.249.731-3.838,4.634-4.74a.182.182,0,0,1,.217.217c-.9,3.9-2.487,5.42-4.738,4.636A.188.188,0,0,1-1912.649,911.8Z",
    transform: "translate(2.537 10.439)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1724",
    "data-name": "Trac\\xE9 1724",
    d: "M-1911.073,914.3c.781-2.249-.733-3.836-4.638-4.737a.18.18,0,0,0-.215.215c.9,3.9,2.489,5.42,4.74,4.634A.187.187,0,0,0-1911.073,914.3Z",
    transform: "translate(0.003 12.493)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1725",
    "data-name": "Trac\\xE9 1725",
    d: "M-1912.648,914.3c-.785-2.249.731-3.838,4.635-4.74a.18.18,0,0,1,.215.217c-.9,3.9-2.487,5.42-4.736,4.636A.183.183,0,0,1-1912.648,914.3Z",
    transform: "translate(2.538 12.492)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1726",
    "data-name": "Trac\\xE9 1726",
    d: "M-1911.073,916.795c.784-2.249-.733-3.836-4.636-4.736a.18.18,0,0,0-.217.215c.9,3.9,2.491,5.42,4.74,4.636A.186.186,0,0,0-1911.073,916.795Z",
    transform: "translate(0.003 14.546)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1727",
    "data-name": "Trac\\xE9 1727",
    d: "M-1912.648,916.8c-.783-2.249.731-3.838,4.635-4.738a.18.18,0,0,1,.217.215c-.9,3.9-2.487,5.42-4.738,4.636A.187.187,0,0,1-1912.648,916.8Z",
    transform: "translate(2.538 14.546)",
    fill: "#f6c459"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgricultureEnvironment);
export default __webpack_public_path__ + "static/media/agriculture_environment.b9f281e5c509b6a86ef86ec74d92ae7e.svg";
export { ForwardRef as ReactComponent };